'use strict'

var Type = require('../type')

module.exports = Type({
  name: 'Troy',
  pattern: /^9792\d{12}$/,
  eagerPattern: /^9792/
})



//////////////////
// WEBPACK FOOTER
// /home/circleci/pickle/~/creditcards-types/types/troy.js
// module id = I59Z
// module chunks = 0